import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.secondary.contrastText,
    backgroundSize: 'cover',
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
  },
  backgroundOverlay: {
    backgroundColor: theme.palette.backgroundColor || theme.palette.blue.light25,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  content: {
    position: 'relative',
    zIndex: 1,
  },
  eventCardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(6),
    flexWrap: 'nowrap',
    gap: '1rem',
    [theme.breakpoints.down('lg')]: {
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
    },
  },
  centered: {
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      justifyContent: 'center !important',
    },
    '& $card': {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
  },
  supportText: {
    fontSize: '1rem',
    color: theme.palette.eyebrowColor || theme.palette.grey.dark,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  eventCard: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '1rem',
    marginRight: '1rem',
    maxWidth: '276px',
    '&:first-child': {
      marginLeft: '0',
    },
    '&:last-child': {
      marginRight: '0',
    },
    [theme.breakpoints.up('lg')]: {
      marginRight: '0',
    },
  },
  textContainer: {
    color: theme.palette.supportiveCopyColor || theme.palette.secondary.dark,
    '&>div>div': {
      fontSize: '1rem',
      lineHeight: '1.5rem',
      marginBottom: '0 !important',
    },
    '&>div>div>a': {
      color: 'white',
      boxShadow: 'rgb(255, 255, 255) 0px 1px 0px',
      '&:hover': {
        color: 'white',
      },
    },
  },
  description: {
    lineHeight: '1.5rem',
  },
  cardImage: {
    display: 'flex',
    alignItems: 'center',
    height: '300px',
    marginBottom: theme.spacing(2),
    '& img': {
      borderRadius: '2px',
    },
  },
  titleContainer: ({ headingAlignment }) => ({
    color: theme.palette.secondary.dark,
    display: 'flex',
    justifyContent: headingAlignment === 'Center' ? 'center' : 'space-between',
    textAlign: headingAlignment === 'Center' ? 'center' : 'left',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  }),
  titleTextWrapper: {
    width: '70%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  richTextWrapper: {
    marginTop: theme.spacing(2),
    '& div.rich-paragraph': {
      marginBottom: 0,
      color: theme.palette.supportiveCopyColor || theme.palette.secondary.dark,
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
        lineHeight: '1.75rem',
      },
    },
  },
  headline: {
    color: theme.palette.headingColor || theme.palette.secondary.light,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
}))

export default useStyles
